<main class="s-siteContainer">

  <nav class="c-path" aria-label="breadcrumb" *ngIf="category">
    <div class="l-container">
      <ul class="c-path__list">
        <li><a [routerLink]="['/']" translate>Naslovnica</a></li>
        <li><a [routerLink]="['/', category.urlSlug]" class="is-active" aria-current="page">{{category.name}}</a></li>
      </ul>
    </div>
  </nav>

  <div class="s-section">
    <div class="l-container">

      <div class="s-section__header">
        <h2 class="s-section__title" *ngIf="category">
          {{category.name}}
        </h2>
      </div>

      <div class="c-media__placeholder is-3:1 is-loading" *ngIf="loading"></div>

      <div class="s-section__main" *ngIf="!loading">
        <div class="s-newsRubric">
          <div class="s-newsRubric__featured" *ngIf="newsPages?.length > 0">
            <div class="l-grid">
              <div class="l-col lg:6 md:12 sm:12">
                <a app-card class="c-card c-card--overlay is-lg" [title]="newsPages[0].title" [showMore]="false"
                   [imageUrl]="(newsPages[0].mainImage || newsPages[0].secondaryImage) | file:'image':'cms':1280"
                   [tags]="newsPages[0].tags" [infoTags]="[{name: newsPages[0].publishedAt | date:'dd.MM.yyyy'}]"
                   [link]="['/', categoryUrl, newsPages[0].urlSlug]"
                   [routerLink]="['/', categoryUrl, newsPages[0].urlSlug]"></a>
              </div>

              <div class="l-col lg:6 md:12 sm:12">
                <div class="l-grid l-grid--20">

                  <div class="l-col lg:6 xs:12" *ngFor="let news of newsPages | slice:1:5; let i = index">
                    <a app-card class="c-card c-card--overlay" [title]="news.title" [showMore]="false"
                       [imageUrl]="(news.mainImage || news.secondaryImage) | file:'image':'cms':640"
                       [tags]="news.tags" [infoTags]="[{name: news.publishedAt | date:'dd.MM.yyyy'}]"
                       [link]="['/', categoryUrl, news.urlSlug]"
                       [routerLink]="['/', categoryUrl, news.urlSlug]"></a>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="s-newsRubric__container" *ngIf="newsPages?.length > 5">
            <div class="l-grid">
              <div class="l-col lg:8 md:12 s-newsRubric__container_main">
                <article app-card class="c-card is-horizontal" *ngFor="let news of newsPages | slice: 5"
                         [title]="news.title" [link]="[news.urlSlug]" [author]="news.author"
                         [tags]="news.tags" [infoTags]="[{name: news.publishedAt | date:'dd.MM.yyyy', type: 'clock'}]"
                         [imageUrl]="(news.mainImage || news.secondaryImage) | file:'image':'cms':640"></article>

                <div class="c-loadMore" *ngIf="totalPages > selectedPage || loadingMore">
                  <button class="c-btn is-secondary" [class.is-loading]="loadingMore"
                          (click)="loadPage(selectedPage + 1)">Učitajte više članaka</button>
                </div>
              </div>

              <div class="l-col lg:3 s-newsRubric__container_side">
                <h2 translate>Najčitanije</h2>

                <div class="is-loading is-4:1" *ngIf="loadingMostRead"></div>

                <article app-card class="c-card is-horizontal" *ngFor="let news of mostReadPages"
                         [title]="news.title" [link]="[news.urlSlug]" [showMore]="false" [author]="news.author"
                         [tags]="news.tags" [infoTags]="[{name: news.publishedAt | date:'dd.MM.yyyy', type: 'clock'}]"
                         [imageUrl]="(news.mainImage || news.secondaryImage) | file:'image':'cms':640"></article>

                <div class="c-banner" *ngIf="banner">
                  <a [href]="banner.url" target="_blank">
                    <img [src]="banner.image | file:'image':'local'" [alt]="banner.name">
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <app-subscription-form *ngIf="!user"></app-subscription-form>

</main>
